import aa from "search-insights";
import type { InsightsClient } from "search-insights";

const appId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID;
const searchKey = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY;

let statisticsConsent = false;
let initialised = false;

function hasStatisticsConsent(): boolean {
  if (typeof window === "undefined") return false;
  const cookiebot = (
    window as Window & { Cookiebot?: { consent?: { statistics?: boolean } } }
  ).Cookiebot;
  return Boolean(cookiebot?.consent?.statistics);
}

function initialiseInsights(): void {
  if (initialised || !appId || !searchKey) return;
  aa("init", { appId, apiKey: searchKey, useCookie: true });
  initialised = true;
}

function syncConsent(): void {
  statisticsConsent = hasStatisticsConsent();
  if (statisticsConsent) initialiseInsights();
}

if (typeof window !== "undefined") {
  syncConsent();
  for (const event of [
    "CookiebotOnConsentReady",
    "CookiebotOnAccept",
    "CookiebotOnDecline",
  ]) {
    window.addEventListener(event, syncConsent);
  }
}

// Forwards to search-insights only once Cookiebot statistics consent is granted;
// before consent every call is dropped, so no insights events are sent.
export const consentGatedInsights: InsightsClient = (...callArgs) => {
  if (!statisticsConsent) return undefined;
  initialiseInsights();
  return aa(...callArgs);
};
